import React from "react";

export type CardProps = {
  children: React.ReactNode;
  className?: string;
};

export function Card({ children, className = "" }: CardProps) {
  return (
    <div
      className={`w-full max-w-[95%] mx-auto shadow-lg bg-[#080808] overflow-visible rounded-xl relative p-6 mt-5 ${className}`}
    >
      {children}
    </div>
  );
}
